import * as LabelPrimitive from "@radix-ui/react-label";

const Label = LabelPrimitive.Root;
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
